(ns frontend.view.components.timeline.entry.oppo-disable
  (:require [common.localization :as loc]
            [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.entry.utils :as utils]))

(defn company-title-generator [company _entry]
  (let [name (-> company :asset/name)]
    (loc/tr :op.company/update [name])))

(defn company-body-generator [_company entry]
  (utils/oppo-named-title-generator entry))

(defmethod te/timeline-entry-view :op.oppo/disable [{entry :entry target-company :target-company :as _arg}]
  (let [email-id (get-in entry [:audit/op-args :email-id])
        timestamp-generator (partial default/timestamp-generator
                                     (fn [_args]
                                       (when email-id
                                         [:span.timeline-item-card-timestamp-highlight
                                          (str " " (loc/tr :via-email))])))]
    (if target-company                                                                              ;;different appearance for company timeline
      [default/timeline-item-view
       entry
       (partial company-title-generator target-company)
       (partial company-body-generator target-company)]
      [default/timeline-item-view entry utils/oppo-named-title-generator default/body-generator timestamp-generator nil])))
